@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.dropdown-menu-single {
  height: auto;
  padding-top: 0;
}

.dropdown-menu-single-item {
  padding: @space-8 0;
  font-size: 14px;
}

.mdash {
  display: flex;
  flex: 1;
  padding: @space-16 0 @space-16 @space-4;
  color: @read-only-shipment-display--mdash--text-color;
}
